import { getTranslateByKey } from "@/main/services/utils";
import { formatCurrency } from "@/main/services/utilsNumber";
import { formatDate, getPatternDate } from "@/main/services/utilsDate";
import * as S from "./claimVoucherCard.styles";

export interface IClaimVoucherCardProps {
	voucherCode: string;
	price: number;
	part: string | null;
	voucherTypeName: string;
	issueDate: string;
	companyName: string;
	statusName: string;
	statusComplement: string | null;
	availableToCollect: boolean;
}

export function ClaimVoucherCard({
	voucherCode,
	price,
	part,
	voucherTypeName,
	issueDate,
	companyName,
	statusName,
	statusComplement,
	availableToCollect,
}: Readonly<IClaimVoucherCardProps>) {
	const displayPart = part && part.trim() !== "" ? part : "-";
	const displayStatus = statusComplement ? `${statusName} (${statusComplement})` : statusName;
	const formattedPrice = formatCurrency(price);
	const formattedDate = formatDate(new Date(issueDate), getPatternDate()) as string;

	const labelYes = getTranslateByKey("information.yes");
	const labelNo = getTranslateByKey("information.no");

	return (
		<S.CardContainer>
			<S.RowHeader>
				<S.TextGroup>
					<S.Label>{getTranslateByKey("information.folio")}</S.Label>
					<S.ValueHighlight>{voucherCode}</S.ValueHighlight>
				</S.TextGroup>
				<S.TextGroupRight>
					<S.Label>{getTranslateByKey("information.price")}</S.Label>
					<S.ValueHighlight>{formattedPrice}</S.ValueHighlight>
				</S.TextGroupRight>
			</S.RowHeader>

			<S.Row>
				<S.TextGroup>
					<S.Label>{getTranslateByKey("information.part")}</S.Label>
					<S.ValueHighlight>{displayPart}</S.ValueHighlight>
				</S.TextGroup>
			</S.Row>

			<S.Row>
				<S.TextGroup>
					<S.Label>{getTranslateByKey("information.company")}</S.Label>
					<S.ValueHighlight>{companyName}</S.ValueHighlight>
				</S.TextGroup>
			</S.Row>

			<S.Grid2Col>
				<S.TextGroup>
					<S.Label>{getTranslateByKey("information.type")}</S.Label>
					<S.ValueHighlight>{voucherTypeName}</S.ValueHighlight>
				</S.TextGroup>
				<S.TextGroupRight>
					<S.Label>{getTranslateByKey("information.issuanceDate")}</S.Label>
					<S.ValueHighlight>{formattedDate}</S.ValueHighlight>
				</S.TextGroupRight>
			</S.Grid2Col>

			<S.Grid2Col>
				<S.TextGroup>
					<S.Label>{getTranslateByKey("information.statusSise")}</S.Label>
					<S.ValueHighlight>{displayStatus}</S.ValueHighlight>
				</S.TextGroup>
				<S.TextGroupRight>
					<S.Label>{getTranslateByKey("information.availableToCollect")}</S.Label>
					<S.ValueIcon>
						{availableToCollect ? <S.SuccessIcon aria-label={labelYes} /> : <S.ErrorIcon aria-label={labelNo} />}
					</S.ValueIcon>
				</S.TextGroupRight>
			</S.Grid2Col>
		</S.CardContainer>
	);
}

export default ClaimVoucherCard;
